import { create } from 'zustand';

import { ExchangeSteps } from './steps';

interface ExchangeState {
  step: ExchangeSteps;
}

interface ExchangeActions {
  setStep: (step: ExchangeSteps) => void;
}
export const useExchangeSteps = create<ExchangeState & ExchangeActions>(
  (set) => ({
    step: 'review',
    setStep: (step) => {
      set({ step });
    },
  }),
);
